<template>
  <div>
    <el-form label-width="100px">
      <el-form-item label="选择日期范围">
        <el-col :span="12">
          <el-date-picker
            v-model="vdate"
            type="daterange"
            alue-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="dateChange">
          </el-date-picker>
        </el-col>
        <el-col  :span="3" >
          <el-input v-model="akeywords" placeholder="请输入店名"></el-input>
        </el-col>
        <el-col  :span="3" >
          <el-input v-model="keywords" placeholder="输入商品名称"></el-input>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="getGoodsDataList()">搜索</el-button>
        </el-col>
        <el-col :span="2">
          &emsp;
          <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-form-item>
    </el-form>
    <el-tabs v-if="$route.path.indexOf('_editor') === -1" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="平台统计" name="goods_count" v-loading="loading">
        <template>
          <el-table :data="allListData" stripe border style="width: 100%" :height="wheight-230">
            <el-table-column prop="distributor_id" label="店铺id"></el-table-column>
            <el-table-column prop="name" label="店铺名称"></el-table-column>
            <el-table-column prop="office_area_name" label="大区名"></el-table-column>
            <el-table-column prop="item_name" label="商品名称"></el-table-column>
            <el-table-column prop="item_fee" label="实收/元"></el-table-column>
            <el-table-column prop="cost_fee" label="成本价/元"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
            <el-table-column prop="profit" label="毛利润/元"></el-table-column>
            <el-table-column prop="category_name" label="分类名称"></el-table-column>
          </el-table>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content-padded content-center">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10,20,50]"
        :total="total_count"
        :page-size="params.pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import json2csv from 'json2csv'
import { getPlatformList } from "../../../api/platform";

export default {
  data () {
    return {
      vdate: '',
      keywords:"",
      akeywords:"",
      loading: true,
      exportloading: false,
      total_count:0,
      activeName: 'goods_count',
      params: {
        start:'',
        end: '',
        page: 1,
        pageSize: 20,
      },
      allListData: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一月',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    exportData () {
      this.exportloading = true;
      this.params.export = 1;
      this.params.keywords=this.keywords;
      this.params.akeywords=this.akeywords;
      getPlatformList(this.params).then(res => {
        this.exportloading = false
        if (res.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          return
        } else if (res.data.url) {
          this.downloadUrl = res.data.url
          this.downloadName = res.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }

      }).catch( error => {
        this.exportloading = false
      })
    },
    getParams () {
      this.params.start = this.params.start
      this.params.end = this.params.end
    },
    handleCurrentChange (page_num) {
      this.loading = false
      this.params.page = page_num
      this.getParams()
      this.getGoodsDataList()
    },
    handleSizeChange (pageSize) {
      this.loading = false
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getParams()
      this.getGoodsDataList()
    },
    createDownLoadClick(content, fileName) {
      const link = document.createElement("a");
      link.href = encodeURI(content);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    MyBrowserIsIE() {
      let isIE = false;
      if (
        navigator.userAgent.indexOf("compatible") > -1 &&
        navigator.userAgent.indexOf("MSIE") > -1
      ) {
        // ie浏览器
        isIE = true;
      }
      if (navigator.userAgent.indexOf("Trident") > -1) {
        // edge 浏览器
        isIE = true;
      }
      return isIE;
    },
    handleClick (tab, event) {
    },
    dateChange (val) {
      if (!val) {
        return false
      }
      this.params.start = val[0]
      this.params.end = val[1]
      this.getGoodsDataList()
    },
    getGoodsDataList () {
      this.loading = true
      this.params.keywords=this.keywords;
      this.params.akeywords=this.akeywords;

      getPlatformList(this.params).then(res => {
        this.allListData = res.data.data.list
        this.loading = false
        this.total_count = res.data.data.pager.count
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '获取统计信息出错'
        })
      })
    },
  },
  mounted () {
    var start = new Date();
    var end = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
    this.vdate = [start, end];
    this.params.start=start;
    this.params.end=end;
    this.getGoodsDataList();

  }
}
</script>



// WEBPACK FOOTER //
// platform.vue?3e2ed27f